export default {
    connectedTikTokAccounts(state) {
        return state.connectedTikTokAccounts;
    },
    authUrl(state) {
        return state.authUrl;
    }
}